import { useEffect, useId, useState } from "react";

export function AnimalImageInput({ file, currentImage, onChange, disabled }: {
  file: File | null;
  currentImage?: string;
  onChange: (file: File | null) => void;
  disabled: boolean;
}) {
  const id = useId();
  const [preview, setPreview] = useState<string>();
  useEffect(() => {
    if (!file) { setPreview(undefined); return; }
    const url = URL.createObjectURL(file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  return <div className="space-y-2">
    <label htmlFor={id}>Animal image</label>
    {(preview || currentImage) && <img src={preview || currentImage} alt="Animal image preview" className="max-h-64 w-full rounded-md object-contain" />}
    <input id={id} type="file" accept="image/*" disabled={disabled} className="block w-full text-sm"
      onChange={(event) => {
        const selected = event.target.files?.[0];
        if (selected) onChange(selected);
        event.target.value = "";
      }} />
    {file && <div className="flex items-center gap-2 text-sm">
      <span>{file.name}</span>
      <button type="button" disabled={disabled} onClick={() => onChange(null)}>Remove selected image</button>
    </div>}
  </div>;
}
